module.exports = __webpack_public_path__ + "img/spellbreaker_kodo_farm_small.9ae39062.png";